__turbopack_context__.v({
  "chicklet_shape": "menu_popover-module-scss-module__x4NeDq__chicklet_shape",
  "menu_text": "menu_popover-module-scss-module__x4NeDq__menu_text",
});
